<template>
  <div>
    <div class="row mb-3">
      <div class="col-2 pr-1">
        <div class="select-wrap">
          <label>Movers</label>
          <input class="form-control"
                 type="text"
                 v-model="carrier.movers"
                 placeholder="Movers"
          />
        </div>
        <error-field :errors="errors" field="movers" />
      </div>
      <div class="col-2 pr-1">
        <div class="select-wrap">
          <label>Trucks</label>
          <input class="form-control"
                 type="text"
                 v-model="carrier.trucks"
                 placeholder="Trucks"
          />
        </div>
        <error-field :errors="errors" field="trucks" />
      </div>
      <button class="btn btn-primary ld-ext-right"
              v-if="$_can('carriers.update')"
              :disabled="loadingButton"
              :class="loadingButton ? 'running' : ''"
              @click.prevent="saveAvailability"
      >
        Save
        <div class="ld ld-ball ld-flip" />
      </button>
    </div>

    <div class="row mb-3">
      <div class="col">
        <full-calendar :event-sources="eventSourcesAvailability"
                       :config="config"
                       ref="calendarAvailability"
        />
      </div>
    </div>

    <!-- Modal daily -->
    <modal v-if="showDayModal"
           @close="showDayModal = false"
    >
      <div slot="header">
        <h4>Change availability</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Date range: </label>
              <flat-pickr v-model="dayAvailability.rangeDates"
                          :config="configDatePicker"
                          class="simple-select-input"
                          placeholder="Select Move Date"
                          name="date"
                          @on-close="onMoveDateChange"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <div class="select-wrap">
              <label>Movers</label>
              <input class="form-control"
                     placeholder="Movers"
                     v-model="dayAvailability.movers"
                     @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="movers" />
          </div>
          <div class="col-6">
            <div class="select-wrap">
              <label>Trucks</label>
              <input class="form-control"
                     placeholder="Trucks"
                     v-model="dayAvailability.trucks"
                     @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="trucks" />
          </div>
          <div class="col">
            <error-field :errors="errors" field="overbooked" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row mt-3">
          <div class="col-12">
            <button class="btn btn-primary pull-right"
                    @click="saveDayAvailability"
            >
              Proceed
            </button>
            <button class="btn btn-secondary"
                    @click="deleteDayAvailability"
            >
              Delete modifier
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>


<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapActions, mapMutations } from 'vuex';
import { FullCalendar } from 'vue-full-calendar';
import moment from 'moment';
import $ from 'jquery';
import flatPickr from 'vue-flatpickr-component';
import Modal from '../Modal';
import ErrorField from '../ErrorField';
import Errors from '../../classes/Errors';

export default {
  components: {
    ErrorField,
    FullCalendar,
    Modal,
    flatPickr,
  },
  props: {
    carrier: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      eventSourcesAvailability: this.fetchEventsAvailability(),
      showDayModal: false,
      showTooltipPrefix: false,
      loadingButton: false,
      buttonDisabled: false,
      errors: new Errors(),
      configDatePicker: {
        dateFormat: 'm/j/Y',
        mode: 'range',
      },
      config: {
        weekends: true,
        forceEventDuration: false,
        displayEventEnd: true, // adds end time to month view
        firstDay: 1,
        editable: false,
        slotEventOverlap: false,
        selectable: true,
        defaultView: 'month',
        header: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        select: (startDate, endDate) => this.showDayModalMethod(startDate, endDate, true),
        eventColor: 'transparent',
        eventTextColor: 'black',
        eventRender(event, element) {
          function giveStyleAssignCarrierAvailability(day, type, dayPeriod) {
            let availability = 0;
            if (type === 'movers') {
              availability =
                dayPeriod.toLowerCase() === 'am'
                  ? day.available_movers_am
                  : day.available_movers_pm;
            } else if (type === 'trucks') {
              availability =
                dayPeriod.toLowerCase() === 'am'
                  ? day.available_trucks_am
                  : day.available_trucks_pm;
            }
            if (availability === 0) {
              return 'orange-yellow-border-text red-border-text';
            }
            if (availability !== parseInt(event[type], 0)) {
              return 'orange-yellow-border-text';
            }
            return 'turquoise-border-text';
          }

          $(element).on('click', () => {
            const startDate = moment(event.start.format('DD/MM/YYYY'), 'DD/MM/YYYY');
            const endDate = moment(event.start.format('DD/MM/YYYY'), 'DD/MM/YYYY').add(1, 'days');
            window.showDayModalMethod(startDate, endDate, true);
          });
          element.append(`
            <div class="d-flex align-items-center justify-content-center p-2">
               <div class="total-carrier-calendar p-2 rounded ml-2">
                  <span class="text-white font-weight-bold">Total</span>
                  <div class="d-flex align-items-center mb-3 text-white mt-3">
                    <span class="mod-icon-movers mr-1" style="width: 18px; height: 18px; display: inline-block"></span>
                    ${event.movers ? event.movers : '/'}
                  </div>
                  <div class="d-flex align-items-center text-white">
                    <span class="mod-icon-trucks mr-1" style="width: 16px; height: 16px; display: inline-block"></span>
                    ${event.trucks ? event.trucks : '/'}
                  </div>
              </div>
               <div style="width: 30%" class="am-av-carrier-calendar p-1 rounded text-center d-flex flex-column align-items-center justify-content-center">
                  <span class="font-weight-bold" style="color: #89909c">AM</span>
                  <div class="d-flex align-items-center mb-3 mt-3">
                    <span class="btn-status btn-amount ${giveStyleAssignCarrierAvailability(
                      event,
                      'movers',
                      'am',
                    )}">${event.available_movers_am}/${event.movers ? event.movers : 0}</span>
                  </div>
                  <div class="d-flex align-items-center text-white">
                    <span class="btn-status btn-amount ${giveStyleAssignCarrierAvailability(
                      event,
                      'trucks',
                      'am',
                    )}">${event.available_trucks_am}/${event.trucks ? event.trucks : 0}</span>
                  </div>
              </div>
               <div class="pm-av-carrier-calendar p-1 rounded text-center d-flex flex-column align-items-center justify-content-center">
                  <span class="font-weight-bold" style="color: #89909c">PM</span>
                  <div class="d-flex align-items-center mb-3 mt-3">
                    <span class="btn-status btn-amount ${giveStyleAssignCarrierAvailability(
                      event,
                      'movers',
                      'pm',
                    )}">${event.available_movers_pm}/${event.movers ? event.movers : 0}</span>
                  </div>
                  <div class="d-flex align-items-center text-white">
                    <span class="btn-status btn-amount ${giveStyleAssignCarrierAvailability(
                      event,
                      'trucks',
                      'pm',
                    )}">${event.available_trucks_pm}/${event.trucks ? event.trucks : 0}</span>
                  </div>
              </div>
            </div>`);
        },
      },
      dayAvailability: {
        date: [],
        movers: '',
        trucks: '',
        startDate: '',
        endDate: '',
        startDateObject: null,
        endDateObject: null,
        rangeDates: null,
      },
    };
  },
  computed: {
    startDateObject() {
      return this.dayAvailability.startDateObject;
    },
    endDateObject() {
      return this.dayAvailability.endDateObject;
    },
  },
  watch: {
    startDateObject() {
      if (this.endDateObject && this.startDateObject) {
        this.showDayModalMethod(this.startDateObject, this.endDateObject);
      }
    },
    endDateObject() {
      if (this.endDateObject && this.startDateObject) {
        this.showDayModalMethod(this.startDateObject, this.endDateObject);
      }
    },
  },
  mounted() {
    this.fetchEventsAvailability();
    window.showDayModalMethod = this.showDayModalMethod;
  },
  methods: {
    ...mapActions(['getCarriers']),
    ...mapMutations(['setCarrier']),
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    onMoveDateChange(selectedDates) {
      this.dayAvailability.startDateObject = selectedDates[0]
        ? moment(selectedDates[0].getTime())
        : '';
      this.dayAvailability.endDateObject = selectedDates[1]
        ? moment(selectedDates[1].getTime())
        : '';
    },
    saveAvailability() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .put(`/carriers/${this.$route.params.id}`, this.carrier)
        .then(() => {
          toastr.success('Successfully saved availability');
          this.$refs.calendarAvailability.$emit('refetch-events');
          this.getCarriers();
          this.$emit('updated');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    saveDayAvailability() {
      const requestData = {
        ...this.dayAvailability,
        startDate: this.dayAvailability.startDateObject
          ? this.dayAvailability.startDateObject.format('DD/MM/YYYY')
          : null,
        endDate: this.dayAvailability.endDateObject
          ? this.dayAvailability.endDateObject.format('DD/MM/YYYY')
          : null,
      };
      axios
        .post(`/carriers/${this.$route.params.id}/availability/store`, requestData)
        .then(() => {
          this.$refs.calendarAvailability.$emit('refetch-events');
          this.showDayModal = false;
          this.dayAvailability = {
            date: [],
            movers: '',
            trucks: '',
            startDate: '',
            endDate: '',
            startDateObject: '',
            endDateObject: '',
            rangeDates: null,
          };
          this.$emit('updated');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    deleteDayAvailability() {
      axios
        .delete(`/carriers/${this.$route.params.id}/availability/delete`, {
          data: { date: this.dayAvailability.date },
        })
        .then(() => {
          this.$emit('updated');
          this.$refs.calendarAvailability.$emit('refetch-events');
          this.showDayModal = false;
          this.dayAvailability = {
            date: [],
            movers: '',
            trucks: '',
            startDate: '',
            endDate: '',
            startDateObject: '',
            endDateObject: '',
            rangeDates: null,
          };
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    showDayModalMethod(startDate, endDate, withSaveDateObjects = false) {
      if (endDate.unix() - startDate.unix() === 86400) {
        this.dayAvailability.startDate = startDate.format('MMM Do YYYY');
        this.dayAvailability.endDate = '';
      } else {
        this.dayAvailability.startDate = startDate.format('MMM Do');
        this.dayAvailability.endDate = endDate.format('MMM Do YYYY');
      }

      if (withSaveDateObjects) {
        if (endDate.unix() - startDate.unix() === 86400) {
          this.dayAvailability.rangeDates = [startDate.toDate()];
        } else {
          this.dayAvailability.rangeDates = [startDate.toDate(), endDate.toDate()];
        }
        this.dayAvailability.startDateObject = startDate;
        this.dayAvailability.endDateObject = endDate;
      }
      if (this.dayAvailability.startDateObject && this.dayAvailability.endDateObject) {
        const dateArray = [];
        let currentDate = moment(startDate);
        const stopDate = moment(endDate);
        while (currentDate < stopDate) {
          dateArray.push(moment(currentDate).format());
          currentDate = moment(currentDate).add(1, 'days');
        }
        this.dayAvailability.date = dateArray;
        axios
          .get(
            `/carriers/${
              this.$route.params.id
            }/availability/calendar?date_from=${this.dayAvailability.startDateObject.format(
              'MM/DD/YYYY',
            )}&date_to=${this.dayAvailability.endDateObject.format('MM/DD/YYYY')}`,
          )
          .then(response => {
            this.dayAvailability.movers = response.data[0].movers;
            this.dayAvailability.trucks = response.data[0].trucks;
          })
          .catch(err => this.errors.record(err.response.data.error));
        this.showDayModal = true;
      }
    },
    fetchEventsAvailability() {
      const vm = this;
      return [
        {
          events(start, end, timezone, callback) {
            axios
              .get(
                `/carriers/${vm.$route.params.id}/availability/calendar?date_from=${start.format(
                  'MM/DD/YYYY',
                )}&date_to=${end.format('MM/DD/YYYY')}`,
              )
              .then(response => {
                callback(response.data);
              })
              .catch(err => this.errors.record(err.response.data.error));
          },
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/carriers/CarriersAvailability.vue